import { motion } from "framer-motion";
import { User, Phone, Mail } from "lucide-react";
import Field from "@/components/booking/Field";
import { STEP_MOTION } from "@/lib/motion-presets";

export default function BookingStep1({ t, form, set, errors }) {
  return (
    <motion.div
      key="s1"
      {...STEP_MOTION}
      className="grid grid-cols-1 md:grid-cols-2 gap-5"
    >
      <Field icon={<User className="w-4 h-4" />} label={t.booking.fields.name} error={errors.name}>
        <input
          data-testid="booking-name-input"
          className={`input-field ${errors.name ? "error" : ""}`}
          value={form.name}
          onChange={(e) => set("name", e.target.value)}
          placeholder="Kovács Anna"
        />
      </Field>

      <Field icon={<Phone className="w-4 h-4" />} label={t.booking.fields.phone} error={errors.phone}>
        <input
          data-testid="booking-phone-input"
          className={`input-field ${errors.phone ? "error" : ""}`}
          value={form.phone}
          onChange={(e) => set("phone", e.target.value)}
          placeholder="+36 30 123 4567"
        />
      </Field>

      <div className="md:col-span-2">
        <Field icon={<Mail className="w-4 h-4" />} label={t.booking.fields.email} error={errors.email}>
          <input
            data-testid="booking-email-input"
            type="email"
            className={`input-field ${errors.email ? "error" : ""}`}
            value={form.email}
            onChange={(e) => set("email", e.target.value)}
            placeholder="email@pelda.hu"
          />
        </Field>
      </div>
    </motion.div>
  );
}
